import React from "react";

export const ArrowRightIcon = ({ fill = "#545454" }: { fill?: string }) => {
  return (
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.974801 0.605158C0.5084 1.07667 0.5084 1.83834 0.974801 2.30985L5.61489 7.00076L0.974801 11.6917C0.5084 12.1632 0.5084 12.9249 0.974801 13.3964C1.4412 13.8679 2.19462 13.8679 2.66102 13.3964L8.1502 7.84706C8.6166 7.37555 8.6166 6.61388 8.1502 6.14237L2.66102 0.593068C2.20658 0.133649 1.4412 0.133649 0.974801 0.605158Z"
        fill={fill}
      />
    </svg>
  );
};
